const palette = {
  black: ['#000000'],
  darkGrey: ['#595959'], // Improved contrast from #7E7E7E (4.5:1 ratio)
  grey: ['#F0F0F0', '#e2e1e1'],
  lightGrey: ['#F8F8F8'],
  white: ['#ffffff'],
  red: ['#8B0000'], // Improved contrast from #A52020 (4.5:1 ratio)
  green: ['#2E7D32'], // Improved contrast from #72A520 (4.5:1 ratio)
  // High contrast colors for accessibility
  highContrast: {
    text: '#000000',
    background: '#ffffff',
    primary: '#0066cc',
    secondary: '#595959',
    error: '#d32f2f',
    success: '#2e7d32',
    warning: '#ed6c02',
    info: '#0288d1'
  }
}

const fonts = {
  main: 'Flexo, -system-ui, -apple-system, sans-serif',
}

const breakpoints = {
  xs: '22.5rem', // 360px
  sm: '43.75rem', // 700px
  md: '60rem', // 960px
  lg: '75rem', // 1200px
  xl: '87.5rem', // 1400px
}

const media = {}
Object.keys(breakpoints).forEach((key) => {
  media[`${key}Down`] = `@media (max-width: ${breakpoints[key]})`
  media[`${key}Up`] = `@media (min-width: ${breakpoints[key]})`
})

const container = {
  default: '88rem', // 1408 px
  narrow: '75rem', // 1200 px
  popup: '64rem', // 1024 px
}

export default {
  palette,
  fonts,
  breakpoints,
  media,
  container,
}
